import { Injectable } from '@angular/core';
import { ValueFrom } from '@vex/model/template-creator';
import { FormControlVisibilityService } from '@vex/services/form-control-visibility.service';
import {
  FormGroup,
  FormArray,
  FormBuilder,
  AbstractControl,
  FormControl,
  Validators,
  FormGroupName
} from '@angular/forms';
import {cloneDeep} from 'lodash';
import { AttributeTypeService } from '@vex/http-service/attribute-type.service';
@Injectable({
  providedIn: 'root'
})
export class AdvanceDataTypeService {
  ValueFrom = ValueFrom;
  attributeTypes: any[] = [];
  constructor(
    private fb: FormBuilder,
    private formControlVisibilityService: FormControlVisibilityService,
    private attributeTypeService: AttributeTypeService
  ) {}

  async bindNewDataType(attribute, customAttributeType, isComplex: boolean = false) {
    if (customAttributeType && !customAttributeType?.AttributeType) {
      let type = this.attributeTypes.find((x) => x.Id == customAttributeType?.AttributeTypeId);
      if(!type){
        type = await this.attributeTypeService.getAttributeTypeById(customAttributeType.AttributeTypeId).toPromise();
        if(type) {
          this.attributeTypes.push(type);
        }
      }
      if (type) {
        customAttributeType.AttributeType = type;
        attribute.BaseType = type.BaseType;
      }
    }
    if (customAttributeType) {
      attribute.DisplayName = customAttributeType.DisplayName;
      attribute.DisplayType = customAttributeType.DisplayType;
      attribute.DefaultValue = customAttributeType.DefaultValue;
      attribute.AttributeTypeId = customAttributeType.AttributeTypeId;
      attribute.IsParentProperty = customAttributeType.IsParentProperty;
      attribute.Instructions = customAttributeType.Instructions;
      attribute.Min = customAttributeType.Min;
      attribute.MinMessage = customAttributeType.MinMessage;
      attribute.Max = customAttributeType.Max;
      attribute.MaxMessage = customAttributeType.MaxMessage;
      attribute.Regex = customAttributeType.Regex;
      attribute.RegexMessage = customAttributeType.RegexMessage;
      attribute.IgnoreWhileProvisioning = customAttributeType.IgnoreWhileProvisioning;
      attribute.IgnoreFromState = customAttributeType.IgnoreFromState;
      attribute.ValidationUrl = customAttributeType.ValidationUrl;
      attribute.IsDropdown = customAttributeType.IsDropdown;
      attribute.UseData = customAttributeType.UseData;
      attribute.DataUrl = customAttributeType.DataUrl;
      attribute.HideExpression = customAttributeType.HideExpression;
      attribute.BlockDetail = customAttributeType.BlockDetail;
      attribute.FunctionTags = customAttributeType.FunctionTags;
      attribute.AttributeType = customAttributeType.AttributeType;
      attribute.DataUrlData = customAttributeType.DataUrlData;
      if (customAttributeType.PrevValue) {
        attribute.PrevValue = customAttributeType.PrevValue;
      }
      if (customAttributeType.Value) {
        attribute.Value = customAttributeType.Value;
      }
      attribute.Hide = customAttributeType.Hide;
      if (attribute.IsVisible == undefined) {
        attribute.IsVisible = true;
      }
      if (isComplex && customAttributeType.AttributeType) {
        attribute.DisplayType = customAttributeType.AttributeType.DisplayType;
        attribute.IsList = customAttributeType.AttributeType.IsList;
        attribute.IsComplex = customAttributeType.AttributeType.IsComplex;
      }
    }
  }

  addAndRemoveControl(form, attribute) {
    if (form && form.get(attribute.Name)) {
      form.removeControl(attribute.Name);
      if (attribute.AttributeType.IsList || attribute.AttributeType.IsComplex) {
        form.addControl(attribute.Name, this.fb.array([]));
      } else {
        form.addControl(attribute.Name, this.fb.control(''));
      }
    }
  }

  getAttributeDataTypeForm(scope, attribute, object) {
    let simpleForm = object.simpleForm;
    let complexForm = object.complexForm;
    let parentForm = object.parentForm;
    let collections = object.collections || [];
    let collection = object.collection || {};
    let isUpdateValidation = object.isUpdateValidation;
    let isComplex = object.isComplex;
    let isReCreateControl = object.isReCreateControl;
    let source = object.source;
    let isBlueprint = object.isBP || false;
    let isRemediation = object.isRemediation || false;
    let isInventory = object.isInventory || false;
    let attributes = object.attributes || [];
    if (attribute.CustomAttributeTypes && attribute.CustomAttributeTypes.length > 0) {
      for (let i = 0; i < attribute.CustomAttributeTypes.length; i++) {
        let customAttributeType = attribute.CustomAttributeTypes[i];
        if (customAttributeType.ShowExpression) {
          let expression = customAttributeType.ShowExpression.replace(/}/g, '').replace(/{/g, '');
          const splittedConditions = expression.split(/[||&&]+/);
          // handle for table column
          if (!simpleForm && !complexForm) {
            let lastAttributeTypeId = attribute.AttributeTypeId;
            this.bindNewDataType(attribute, customAttributeType, isComplex);
            if (isUpdateValidation && lastAttributeTypeId != attribute.AttributeTypeId) {
              this.addAndRemoveControl(simpleForm, attribute);
              this.formControlVisibilityService.updateAttributeValidation(
                attribute,
                simpleForm,
                scope
              );
            }
            break;
          }
          let evalFlag = false;
          for (let i = 0; i < splittedConditions.length; i++) {
            const propertyName = this.formControlVisibilityService.getPropertyNameFromCondition(
              splittedConditions[i]
            );
            if (isInventory && 'global.inventory' == propertyName) {
              expression = expression.replace('global.inventory', true);
            } else if (isBlueprint && 'global.blueprint' == propertyName) {
              expression = expression.replace('global.blueprint', true);
            } else if (isRemediation && 'global.remediation' == propertyName) {
              expression = expression.replace('global.remediation', true);
            } else if (propertyName.indexOf('.') === -1) {
              let propertyValue = '';
              let formValue: any;

              if (simpleForm && simpleForm.get(propertyName)) {
                formValue = simpleForm.get(propertyName).value;
              } else {
                if (complexForm && complexForm.get(propertyName)) {
                  formValue = complexForm.get(propertyName).value;
                }
              }

              if (!formValue) {
                formValue = attributes.find((x) => x.Name == propertyName)?.Value;
              }

              if (!formValue) {
                formValue = '';
              }
              propertyValue = "'" + formValue + "'";
              let condition = splittedConditions[i].replace(propertyName, propertyValue);
              expression = expression.replace(splittedConditions[i], condition);
            } else if (propertyName.indexOf('.') !== -1) {
              let propertyToFind = propertyName.split('.');
              let attributeValue = this.formControlVisibilityService.matchWithParenAttributeValue(
                parentForm,
                collections,
                collection,
                propertyToFind
              );
              if (!attributeValue) {
                attributeValue = '';
              }
              let condition = splittedConditions[i].replace(
                propertyName,
                "'" + attributeValue + "'"
              );
              expression = expression.replace(splittedConditions[i], condition);
            }
            evalFlag = true;
          }
          let result = null;
          try {
            result = eval(expression);
          } catch {
            result = null;
          }
          if (evalFlag && result) {
            let lastAttributeTypeId = attribute.AttributeTypeId;
            this.bindNewDataType(attribute, customAttributeType, isComplex);
            if (isUpdateValidation && lastAttributeTypeId != attribute.AttributeTypeId) {
              if (!isReCreateControl) {
                this.addAndRemoveControl(simpleForm, attribute);
              } else {
                if (attribute.AttributeType.IsList) {
                  let values = simpleForm.get(attribute.Name).value || [];
                  simpleForm.removeControl(attribute.Name);
                  simpleForm.addControl(attribute.Name, this.fb.array([]));
                  let control = simpleForm.get(attribute.Name) as FormArray;
                  values.forEach((value) => {
                    control.push(
                      new FormControl(
                        value,
                        this.formControlVisibilityService.getValidationProps(
                          attribute,
                          isBlueprint,
                          source
                        )
                      )
                    );
                  });
                }
              }
              this.formControlVisibilityService.updateAttributeValidation(
                attribute,
                simpleForm,
                scope
              );
            }
            break;
          }
        }
      }
    }

    if (attribute.AttributeTypeId == '' || !attribute.AttributeType) {
      this.bindDefaultDataType(attribute, isComplex);
    }
  }

  getAttributeDataTypeForValue(
    attribute,
    isDefault: boolean = false,
    object: any = {},
    isCallFromTemplate: boolean = false,
    scope: any = {}
  ) {
    let isComplex: boolean = false;
    if (!isDefault) {
      let collections = object.collections;
      let collection = object.collection;
      isComplex = object.isComplex;
      let data = object.data;
      let attributeName = object.attributeName;
      let newValue = object.newValue;
      let allFormValues = object.allFormValues;
      let isBlueprint = object.isBP || false;
      let isRemediation = object.isRemediation || false;
      let isInventory = object.isInventory || false;
      if (attribute.CustomAttributeTypes && attribute.CustomAttributeTypes.length > 0) {
        for (let i = 0; i < attribute.CustomAttributeTypes.length; i++) {
          let customAttributeType = attribute.CustomAttributeTypes[i];
          if (customAttributeType.ShowExpression) {
            let expression = customAttributeType.ShowExpression.replace(/}/g, '').replace(/{/g, '');
            const splittedConditions = expression.split(/[||&&]+/);
            let evalFlag = false;
            if (isCallFromTemplate) {
              for (let i = 0; i < splittedConditions.length; i++) {
                const propertyName = this.formControlVisibilityService.getPropertyNameFromCondition(
                  splittedConditions[i]
                );
                if (isInventory && 'global.inventory' == propertyName) {
                  expression = expression.replace('global.inventory', true);
                } else if (isBlueprint && 'global.blueprint' == propertyName) {
                  expression = expression.replace('global.blueprint', true);
                } else if (isRemediation && 'global.remediation' == propertyName) {
                  expression = expression.replace('global.remediation', true);
                } else if (propertyName.indexOf('.') === -1) {
                  let propertyValue = '';
                  let formValue = data[propertyName];
                  if (formValue) {
                    if (!formValue) {
                      formValue = '';
                    }
                    propertyValue = "'" + formValue + "'";
                  } else if (attributeName && attributeName == propertyName) {
                    if (!newValue) {
                      newValue = '';
                    }
                    propertyValue = "'" + newValue + "'";
                  } else {
                    formValue = scope.getFormValue(propertyName);
                    if (!formValue) {
                      formValue = '';
                    }
                    propertyValue = "'" + formValue + "'";
                  }
                  const condition = splittedConditions[i].replace(propertyName, propertyValue);
                  expression = expression.replace(splittedConditions[i], condition);
                  evalFlag = true;
                } else if (propertyName.indexOf('.') !== -1) {
                  const collectionName = propertyName.split('.')[0];
                  let propertiesToFind = propertyName.replace(collectionName + '.', '').split('.');
                  let attributeValue: any;
                  let complexData: any = allFormValues?.find(
                    (value) => value.TerraformResourceName == collectionName
                  );
                  if (complexData) {
                    for (let j = 0; j < propertiesToFind.length; j++) {
                      if (
                        complexData[propertiesToFind[j]] != undefined &&
                        complexData[propertiesToFind[j]] != ''
                      ) {
                        complexData = complexData[propertiesToFind[j]];
                        if (j == propertiesToFind.length - 1) {
                          attributeValue = complexData;
                          break;
                        } else {
                          // Add more code for specific index or n index
                          complexData = complexData[0];
                        }
                      }
                    }
                  } else {
                    let coll = collections.find((x) => x.ResourceName == collectionName);
                    let propertyToFind = propertyName.split('.');
                    if (coll) {
                      attributeValue = this.formControlVisibilityService.getLabelValue(
                        coll.BlueprintCollectionAttributes,
                        propertyToFind
                      );
                    }
                  }
                  if (!attributeValue) {
                    attributeValue = '';
                  }
                  const condition = splittedConditions[i].replace(
                    propertyName,
                    "'" + attributeValue + "'"
                  );
                  expression = expression.replace(splittedConditions[i], condition);
                  evalFlag = true;
                }
              }
            } else {
              for (let i = 0; i < splittedConditions.length; i++) {
                const propertyName = this.formControlVisibilityService.getPropertyNameFromCondition(
                  splittedConditions[i]
                );
                if (isInventory && 'global.inventory' == propertyName) {
                  expression = expression.replace('global.inventory', true);
                } else if (propertyName.indexOf('.') === -1) {
                  let propertyValue = '';
                  let formValue: any;
                  if (isComplex) {
                    formValue = data[propertyName];
                  } else {
                    let collectionAttribute = collection.BlueprintCollectionAttributes?.find(
                      (x) => x.Name.toLowerCase() == propertyName
                    );
                    if (collectionAttribute) {
                      formValue = collectionAttribute.Value;
                    }
                  }
                  if (!formValue) {
                    formValue = '';
                  }
                  propertyValue = "'" + formValue + "'";
                  const condition = splittedConditions[i].replace(propertyName, propertyValue);
                  expression = expression.replace(splittedConditions[i], condition);
                  evalFlag = true;
                } else if (propertyName.indexOf('.') !== -1) {
                  const propertyToFind = propertyName.split('.');
                  let attributeValue =
                    this.formControlVisibilityService.matchWithParenAttributeValue(
                      undefined,
                      collections,
                      collection,
                      propertyToFind
                    );
                  if (!attributeValue) {
                    attributeValue = '';
                  }
                  const condition = splittedConditions[i].replace(
                    propertyName,
                    "'" + attributeValue + "'"
                  );
                  expression = expression.replace(splittedConditions[i], condition);
                  evalFlag = true;
                }
              }
            }

            let result = null;
            try {
              result = eval(expression);
            } catch {
              result = null;
            }

            if (evalFlag && result) {
              this.bindNewDataType(attribute, customAttributeType, isComplex);
              break;
            }
          }
        }
      }
    }

    if (attribute.AttributeTypeId == '' || !attribute.AttributeType) {
      this.bindDefaultDataType(attribute, isComplex);
    }
  }

  bindDefaultDataType(attribute, isComplex) {
    if (!attribute.CustomAttributeTypes) {
      let type = this.attributeTypes.find((x) => x.Id == attribute.AttributeTypeId);
      if (type) {
        attribute = cloneDeep(type);
      }
    }
    if(attribute.CustomAttributeTypes && attribute.CustomAttributeTypes.length > 0) {
      this.bindNewDataType(attribute, attribute.CustomAttributeTypes[0], isComplex);
    }
  }

  getRowValidation(defaultValue, attribute, control, isCallFromBP: boolean = false, source: string = '', isNeedRequired: boolean = true): object {
    if (attribute.AttributeType.IsList) {
      if (!defaultValue) {
        defaultValue = {};
      }
      return {
        [attribute.Name]: [
          defaultValue[attribute.Name],
          [...this.formControlVisibilityService.getValidationProps(attribute, isCallFromBP, source, isNeedRequired)]
        ]
      };
    }
    if (attribute.AttributeType.IsComplex) {
      const props = {};
      if (!defaultValue) {
        defaultValue = {};
      }
      (props['_ComplexAttributes'] = [Object.assign([], attribute.AttributeType.AttributeTypes)]),
        attribute.AttributeType.AttributeTypes.forEach((subAttributeType) => {
          this.getAttributeDataTypeForValue(subAttributeType, true);
          if (
            subAttributeType.DataGeneratedBy == 'User' ||
            (subAttributeType.DataGeneratedBy == 'CSP' && subAttributeType.DisplayType == 2)
          ) {
            if (subAttributeType.IsComplex) {
              props[subAttributeType.Name] = [
                defaultValue[subAttributeType.Name] || [],
                [...this.formControlVisibilityService.getValidationProps(subAttributeType, isCallFromBP, source, isNeedRequired)]
              ];
            } else if (subAttributeType.IsList) {
              let defaultVal: any[] = [];
              if (subAttributeType.DefaultValue && subAttributeType.DefaultValue != '')
                defaultVal = subAttributeType.DefaultValue.split(',');
              // props[subAttributeType.Name] = [
              //   defaultValue[subAttributeType.Name] || defaultVal,
              //   [...this.getValidationProps(subAttributeType)]
              // ];
              if (subAttributeType.IsDropdown) {
                props[subAttributeType.Name] = new FormControl(
                  defaultValue[subAttributeType.Name] || defaultVal,
                  [...this.formControlVisibilityService.getValidationProps(subAttributeType, isCallFromBP, source, isNeedRequired)]
                );
              } else {
                props[subAttributeType.Name] = this.fb.array([]);
                let controls = props[subAttributeType.Name] as FormArray;
                if (defaultValue[subAttributeType.Name]) {
                  defaultValue[subAttributeType.Name].forEach((subValue) => {
                    controls.push(
                      new FormControl(subValue, [
                        ...this.formControlVisibilityService.getValidationProps(subAttributeType, isCallFromBP, source, isNeedRequired)
                      ])
                    );
                  });
                }
              }
            } else {
              if (subAttributeType.BaseType == 'bool') {
                props[subAttributeType.Name] = [
                  this.formControlVisibilityService.getBoolValue(
                    subAttributeType,
                    defaultValue[subAttributeType.Name],
                    true
                  ),
                  []
                ];
              } else {
                // Before Add set index value
                if (subAttributeType.FunctionTags) {
                  let index = 0;
                  if (subAttributeType.FunctionTags.findIndex((tag) => tag == 'IndexValue') > -1) {
                    subAttributeType.DefaultValue = index;
                    control.controls.forEach((element) => {
                      element.get(subAttributeType.Name).setValue(index);
                      index++;
                      subAttributeType.DefaultValue = index;
                    });
                  }
                }
                let value = defaultValue[subAttributeType.Name] || subAttributeType.DefaultValue;
                if (
                  subAttributeType.BaseType == 'int' &&
                  subAttributeType.DataGeneratedBy == 'User' &&
                  defaultValue[subAttributeType.Name] === 0
                ) {
                  value = 0;
                }
                props[subAttributeType.Name] = new FormControl(value, [
                  ...this.formControlVisibilityService.getValidationProps(subAttributeType, isCallFromBP, source, isNeedRequired)
                ]);
              }
            }
          }
        });
      return props;
    }
    if (!defaultValue) {
      defaultValue = '';
    }
    return {};
  }
}
